import { Alert, AlertTitle, Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { accountSetupCopy } from '../utils/userFacingCopy';

export default function AccountSetupBanner() {
  const { profileSetupStatus } = useAuth();

  if (!profileSetupStatus?.isRestricted) {
    return null;
  }

  const blocking = profileSetupStatus.missingItems.filter((item) => item.blocksAccess);
  const advisory = profileSetupStatus.missingItems.filter((item) => !item.blocksAccess);

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <AlertTitle>{accountSetupCopy.bannerTitle}</AlertTitle>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {accountSetupCopy.bannerLead}
      </Typography>
      {blocking.length > 0 && (
        <Box component="ul" sx={{ m: 0, pl: 2.5, mb: advisory.length > 0 ? 1 : 0 }}>
          {blocking.map((item) => (
            <Typography key={item.code} component="li" variant="body2">
              {accountSetupCopy.missingItemLabel(item.code)}
            </Typography>
          ))}
        </Box>
      )}
      {advisory.length > 0 && (
        <>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            Also recommended:
          </Typography>
          <List dense disablePadding sx={{ pl: 1 }}>
            {advisory.map((item) => (
              <ListItem key={item.code} disablePadding sx={{ display: 'list-item', listStyleType: 'disc', ml: 2 }}>
                <ListItemText
                  primary={accountSetupCopy.missingItemLabel(item.code)}
                  primaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }}
                />
              </ListItem>
            ))}
          </List>
        </>
      )}
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {accountSetupCopy.bannerContact}
      </Typography>
    </Alert>
  );
}
